// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H15V7.5H13V4H4V13H7.5V15H2V2ZM9 9H22V22H9V9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-copy-filled')
export default class CopyFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'copy-filled',
    }
  }
}
